/**
 * Checks if an EML file is a draft by looking for the x-unsent header
 */
export async function checkIfDraftEml(file: File): Promise<boolean> {
    try {
        const text = await file.text();
        // Only check the first 5000 characters for performance (headers are at the top)
        const headerSection = text.substring(0, 5000);
        return /^x-unsent:\s*1\s*$/im.test(headerSection);
    } catch {
        return false;
    }
}
